module.exports = __webpack_public_path__ + "static/media/behance.29b3f0a7.svg";